import { render, staticRenderFns } from "./ValidityAnimatedIcon.vue?vue&type=template&id=5acda1f4&scoped=true"
import script from "./ValidityAnimatedIcon.vue?vue&type=script&lang=js"
export * from "./ValidityAnimatedIcon.vue?vue&type=script&lang=js"
import style0 from "./ValidityAnimatedIcon.vue?vue&type=style&index=0&id=5acda1f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acda1f4",
  null
  
)

export default component.exports